// extracted by mini-css-extract-plugin
export default {"Gridcontainer":"sucess_Gridcontainer__LaHbC","bridecard":"sucess_bridecard__rEIXa","sccscr":"sucess_sccscr__-2KLw"};